import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import useDelivery from "./useDelivery";
import Style from "../addStore.module.scss";
const Delivery = ({
  formik,
  getFieldError,
  storeState,
  setStoreState,
  checkError,
  isStoreCreate,
}) => {
  const {
    time,
    handleCloseModal,
    handleTimeChange,
    handleNext,
    daysOfWeek,
    handleToggle,
    enabledDays,
    // getMinToTime,
    // curbTimeError,
  } = useDelivery({ formik, storeState, setStoreState });

  return (
    <>
      <div className="form-check form-switch pro-mb-4">
        <input
          className="form-check-input cursor-pointer"
          type="checkbox"
          role="switch"
          id="office_delivery"
          name="office_delivery"
          checked={Boolean(formik.values?.office_delivery === 1) ?? false}
          onChange={(e) => {
            formik.setFieldValue("office_delivery", e.target.checked ? 1 : 2);
          }}
        />
        <label htmlFor="office_delivery" className="pro-check-label">
          Set Office Delivery Hours
        </label>
        {getFieldError("office_delivery") && (
          <div className={`${Style.form_toggle_err_msg}`}>
            {getFieldError("office_delivery") ||
              "Please select at least one day's hours."}
          </div>
        )}
      </div>

      {formik.values?.office_delivery === 1 && (
        <>
          {daysOfWeek.map((day) => (
            <div
              key={day}
              className={`pro-d-flex pro-flex-column pro-mb-4 ${Style.time_wrap}`}
            >
              <label className="pro-font-sm pro-mb-1 pro-fw-medium">
                {day}
              </label>
              <div
                className={`pro-d-flex pro-items-center ${Style.time_picker_wrap}`}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={time[day]?.from || ""}
                    onChange={(newValue) =>
                      handleTimeChange(day, "from", newValue)
                    }
                    className="time-picker"
                    disabled={
                      !enabledDays[day] || formik.values.office_delivery === 0
                    }
                  />

                  <span className="pro-px-3 pro-d-flex pro-items-center">
                    <span className="material-symbols-outlined x4">
                      {" "}
                      remove{" "}
                    </span>
                  </span>

                  <TimePicker
                    value={time[day]?.to || ""}
                    onChange={(newValue) =>
                      handleTimeChange(day, "to", newValue)
                    }
                    className="time-picker"
                    // minTime={getMinToTime(day, time[day]?.from)}
                    disabled={
                      !enabledDays[day] || formik.values.office_delivery === 0
                    }
                  />
                  <div className="form-check form-switch pro-mb-0 pro-ms-auto">
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id={`${day}-switch`}
                      checked={enabledDays[day] || false}
                      onChange={() => handleToggle(day)}
                    />
                  </div>
                </LocalizationProvider>
              </div>
            </div>
          ))}
        </>
      )}
      <div className={`col-12 pro-d-flex pro-justify-end pro-pb-5 pro-mt-auto`}>
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleCloseModal}
          type="button"
        >
          Cancel
        </Button>

        {/* <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={checkError}
          disabled={isStoreCreate}
        >
          {storeState?.isEdit && !isStoreCreate
            ? "Update"
            : isStoreCreate && storeState?.isEdit
            ? "Updating..."
            : isStoreCreate && !storeState?.isEdit
            ? "Creating..."
            : "Create"}
        </Button> */}
        <Button className={"pro-btn-primary lg pro-ms-3"} onClick={handleNext}>
          {"Next"}
        </Button>
      </div>
    </>
  );
};

export default Delivery;
